import React, {useEffect, useState} from 'react';
import {Outlet, useNavigate} from 'react-router-dom';
import {useDashboard} from "../utilities/context/dashboard/dashboard-context";
import useAuthCalls from "../utilities/custom-hooks/auth-calls";
import {doGetSubscriptionHistory, doGetUser, doGetUserSubscriptions, doGetWhoAmI} from "../logic/users";
import Layout from "../components/Layout/Layout";
import Loading from "../components/UI/Loading";
import DashboardLayout from "../components/Layout/DashboardLayout";

const Dashboard = () => {

    const {call} = useAuthCalls();
    const {user_id, setUserId, loadUser, loadSubscription, loadHistory} = useDashboard();

    const [loading, setLoading] = useState(false);

    const navigate = useNavigate();

    function returnToLogin(message) {
        if (message) console.warn(message);
        navigate('/login');
    }

    useEffect(() => {
        const load = async () => {
            if (user_id) {
                setLoading(true);
                await call(
                    () => doGetUser(user_id),
                    (res) => {
                        if (res) {
                            loadUser(res);
                        }
                    },
                    (e) => {
                        returnToLogin(e);
                    }
                );
                await call(
                    () => doGetUserSubscriptions(user_id),
                    (res) => {
                        console.log(res);
                        if (res && res.id) {
                            loadSubscription(res);
                        } else {
                            loadSubscription(null);
                        }
                    },
                    (e) => {
                        returnToLogin(e);
                    }
                );
                await call(
                    () => doGetSubscriptionHistory(user_id),
                    (res) => {
                        if (res) {
                            loadHistory(res);
                        }
                    },
                    (e) => {
                        returnToLogin(e);
                    }
                )
                setLoading(false);
            } else {
                setLoading(true);
                await call(
                    () => doGetWhoAmI(),
                    async (res) => {
                        if (res.user) {
                            await setUserId(res.user);
                        }
                    },
                    (e) => {
                        returnToLogin(e);
                    }
                );
                setLoading(false);
            }
        }

        load();
    }, [user_id])

    return (
        <DashboardLayout current='/dashboard'>
            <div className="h-full w-full bg-ea_gray_dark flex-1 min-h-screen text-white flex flex-col items-center" >
                {loading
                    ? <Loading label="Caricamento profilo" className="mt-8 text-lg"/>
                    : <div style={{maxWidth: "1200px"}} className="w-full"><Outlet/></div>
                }
            </div>
        </DashboardLayout>
    );
};

export default Dashboard;